export function scrollTo(section) {
  const anchor = document.querySelector(section);
  anchor.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  });
}
